module.exports = __webpack_public_path__ + "static/media/study 201109.c54c2b87.png";